import { Icon, ListItemButton } from "@mui/material";
import MDBox from "components/MDBox";
import UiTypography from "components/base/UiTypography";
import { WorksheetProduct } from "generated/graphql";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import formatCentsToUSD from "utils/money/formatCentsToUSD";
import { unitLabel } from "./worksheetFormValues";

type WorksheetCatalogRowProps = {
  product: WorksheetProduct;
  disabled?: boolean;
  onSelect: (id: string) => void;
};

export default function WorksheetCatalogRow({
  product,
  disabled,
  onSelect,
}: WorksheetCatalogRowProps) {
  return (
    <ListItemButton
      disabled={disabled}
      onClick={() => onSelect(product.id)}
      sx={{ borderRadius: "8px", gap: "8px" }}
    >
      <MDBox flexGrow={1} minWidth={0}>
        <UiTypography uiVariant="body-sm" sx={{ fontWeight: 600 }}>
          {product.name}
        </UiTypography>
        <UiTypography uiVariant="body-sm" sx={{ color: draftColors.textSecondary }}>
          {product.sellingQuantity} {unitLabel(product.unit)} @{" "}
          {formatCentsToUSD(product.sellingRate)}
        </UiTypography>
      </MDBox>
      <Icon fontSize="small" sx={{ color: draftColors.textAction }}>
        add_circle_outline
      </Icon>
    </ListItemButton>
  );
}
